/**
 * Hook to check if a user has a specific feature enabled
 * @param {string} featureName - The name of the feature to check
 * @returns {boolean} - Whether the user has the feature enabled
 */
export function userHasFeature(featureName: string): boolean {
    try {
        const user = window.gon?.currentUser
        return (
            user?.features?.some(
                (feature: string | { name?: string }) =>
                    (typeof feature === 'string' ? feature : feature?.name) === featureName,
            ) ?? false
        )
    } catch {
        return false
    }
}

export default function useUserHasFeature(featureName: string): boolean {
    return userHasFeature(featureName)
}
